import { Component } from '@angular/core';
import { DataTableBase } from '../../../../core/base/components/data-table-base/data-table-base';
import { FeiColumn } from '../../../../core/base/interfaces/fei-column.interface';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { EnergyIdCreateUpdateDeleteComponent } from './energy-id-create-update-delete/energy-id-create-update-delete.component';
import { CrudModeEnum } from '../../../../core/base/enum/crud-mode.enum';
import { EnergyIdModel } from '../../../../core/models/energy-id.model';
import { EnergyIdService } from './energy-id.service';
import { ENUM_PERMISSIONS } from '../../../../core/enums/permission.enum';
import { AuthService } from '../../../../core/services/auth.service';
import { Observable } from 'rxjs';
import { ObjectApiInterface } from '../../../../core/base/interfaces/object-api.interface';

@Component({
  selector: 'vex-energy-id',
  templateUrl: './energy-id.component.html',
  styleUrls: ['./energy-id.component.scss'],
})
export class EnergyIdComponent extends DataTableBase<EnergyIdModel> {
  // PRED-3175 : seule la pagination est persistée dans l'URL (filtres hors périmètre)
  protected persistFiltersInUrl = false;
  canShowArchives = false;

  feisColumns: Array<FeiColumn> = [
    { label: "Type d'énergie", column: 'genericEnergyId', propertyDisplay: 'genericEnergyId.energyType' },
    { label: 'Point de Livraison', column: 'energyIdId' },
    { label: 'Établissement(s)', column: 'establishments', type: 'custom', width: '30%' },
    { label: 'Bâtiment(s)', column: 'buildings', type: 'custom', width: '30%' },
    { label: 'Information complémentaire', column: 'additionalInfo' },
    { label: 'Fournisseur', column: 'supplier', propertyDisplay: 'supplier.label' },
    //     {label: 'Bâtiment Contact Achat', column: 'favoriteBuilding', propertyDisplay: 'favoriteBuilding.label'},
    { label: 'Créé le', column: 'createdAt', type: 'date' },
    { label: 'Édité le', column: 'updatedAt', type: 'date' },
    {
      label: '',
      column: 'actions',
      canUpdate: this.authService.hasPermission(ENUM_PERMISSIONS.UPDATE_ENERGY_ID),
      canArchive: this.authService.hasPermission(ENUM_PERMISSIONS.DELETE_ENERGY_ID),
    },
  ];

  entityName = 'Energies';
  ENUM_PERMISSION = ENUM_PERMISSIONS;

  constructor(
    private dialog: MatDialog,
    private router: Router,
    public service: EnergyIdService,
    public authService: AuthService,
  ) {
    super();
    this.displayedColumns = this.feisColumns.map(x => x.column);
  }

  protected setupTable(): void {
    this.checkPermission();
  }

  protected buildFilters(): Record<string, unknown> {
    return { ...this.filters, requiredFields: ['*'], isUserEnergyId: true };
  }

  protected fetch(filters: Record<string, unknown>): Observable<ObjectApiInterface<EnergyIdModel[]>> {
    return this.service.findAllWithFullRelation(
      this.pageIndex,
      this.pageSize,
      this.sortField,
      this.sortOrder,
      this.search,
      filters,
    );
  }

  createItem(): void {
    this.dialog
      .open(EnergyIdCreateUpdateDeleteComponent, {
        width: '700px',
        data: {
          mode: CrudModeEnum.Create,
        },
      })
      .afterClosed()
      .subscribe((energyId: EnergyIdModel) => {
        if (energyId) {
          this.initData();
        }
      });
  }

  updateItem(element: any): void {
    this.dialog
      .open(EnergyIdCreateUpdateDeleteComponent, {
        width: '700px',
        data: {
          defaults: element,
          mode: CrudModeEnum.Update,
        },
      })
      .afterClosed()
      .subscribe((energyId: EnergyIdModel) => {
        if (energyId) {
          this.initData();
        }
      });
  }

  deleteItem(element: any) {
    // this.dialog.open(EquipmentCreateUpdateDeleteComponent, {
    //   data: {
    //     defaults: element,
    //     name: `${element.reference}`,
    //     mode: CrudModeEnum.Delete
    //   }
    // }).afterClosed().subscribe((equipment: EquipmentModel) => {
    //   if (equipment) {
    //     this.initData();
    //   }
    // });
  }

  importItems() {
    this.dialog
      .open(EnergyIdCreateUpdateDeleteComponent, {
        width: '500px',
        data: {
          mode: CrudModeEnum.Import,
        },
      })
      .afterClosed()
      .subscribe((energyId: EnergyIdModel[]) => {
        if (energyId) {
          this.initData();
        } else {
        }
      });
  }

  archiveItem(element: any) {
    this.dialog
      .open(EnergyIdCreateUpdateDeleteComponent, {
        data: {
          mode: CrudModeEnum.Archive,
          defaults: element,
        },
      })
      .afterClosed()
      .subscribe((energyId: EnergyIdModel) => {
        if (energyId) {
          this.initData();
        }
      });
  }

  checkPermission() {
    this.subscription.add(
      this.authService.getCurrentUserPermissions$().subscribe(permissions => {
        if (permissions.includes(ENUM_PERMISSIONS.READ_ENERGY_ID)) {
          this.canShowArchives = true;
        }
      }),
    );
  }
}
